import React, { useState, useEffect } from "react";
import "./../styles/ImageGallery.scss";
import indirlogopng from "./../img/download-icon.png";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import leftmenuicon from "./../img/left-menu-icon-mobile.png";
import Api from "../common/api";

const ImageGallery = () => {
  const [tabs, setTabs] = useState([]);
  const lang = localStorage.getItem("lang");
  const [currentTab, setCurrentTab] = useState([]);
  const [currentTabId, setCurrentTabId] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [images, setImages] = useState([]);
  
  const [isMobileActive, setIsMobileActive] = useState(false);

  React.useEffect(() => {
    Api.get("/photos/list").then((res) => {
      setTabs(res.data.items);
      setCurrentTab(res.data.items[0]);
      imageChangeHandler(0);
      setCurrentTabId(res.data.items[0].id);
    });
  }, []);

  const imageChangeHandler = (direction) => {
    if (direction === 1) {
      if (photoIndex === images.length - 1) {
        return setPhotoIndex(0);
      }
      setPhotoIndex(photoIndex + 1);
    }
    if (direction === -1) {
      if (photoIndex === 0) {
        return setPhotoIndex(images.length - 1);
      }
      setPhotoIndex(photoIndex - 1);
    }
  };

  const imgOnClickHandler = (i) => {
    setPhotoIndex(i);
    setIsOpen(true);
  };

  const adClick = (id) => {
    setCurrentTabId(id);
    const tab = tabs.find((tab) => tab.id === id);
    setCurrentTab(tab);
    setIsMobileActive(false)
  };

  useEffect(
    (tab) => {
      return currentTab && currentTab.content && currentTab.content.length > 0
        ? setImages(currentTab.content.map((a) => a.file_name))
        : null;
    },
    [currentTab]
  );

  const renderContent = () => {
    return currentTab && currentTab.content && currentTab.content.length > 0
      ? currentTab.content.map((item, i) => {
          return (
            <>
              <div className="gallery-img-box">
                <img
                  style={{ cursor: "pointer" }}
                  onClick={() => imgOnClickHandler(i)}
                  className="gallery-image"
                  src={
                    "https://sankoenerji.com.tr/" +
                    item.file_name.split("/Uploads/")[0] +
                    "Uploads/thumbs/" +
                    item.file_name.split("/Uploads/")[1]
                  }
                  alt={item.file_type}
                />
                <p>{item.Title}</p>
                <a
                  href={"https://sankoenerji.com.tr" + item.file_name}
                  download={item.file_type}
                  rel="noopener noreferrer"
                >
                  <img
                    className="download-btn-absolute"
                    src={indirlogopng}
                    alt={item.file_type}
                  />
                </a>
                {/* <h5 style={{ marginTop: "20px", fontWeight: "300" }}>
                  {item.file_type}
                </h5> */}
              </div>
              {isOpen && (
                <Lightbox
                  mainSrc={
                    "https://sankoenerji.com.tr" + images[photoIndex]
                  }
                  nextSrc={
                    "https://sankoenerji.com.tr" +
                    images[(photoIndex + 1) % images.length]
                  }
                  prevSrc={
                    "https://sankoenerji.com.tr" +
                    images[(photoIndex + images.length - 1) % images.length]
                  }
                  onCloseRequest={() => setIsOpen(false)}
                  onMovePrevRequest={() => imageChangeHandler(-1)}
                  onMoveNextRequest={() => imageChangeHandler(1)}
                  animationDuration="100"
                />
              )}
            </>
          );
        })
      : null;
  };

  return (
    <div className="corporate-content-container container-sm">
      <div className="tab-container">
        <ul>
          {tabs
            ? tabs.map((tab) => {
                return (
                  lang == "en" ? (
                    tab.Title_En ? (
                  <li
                    className={currentTabId === tab.id ? "active" : null}
                    onClick={() => adClick(tab.id)}
                    key={tab.id}
                  >
                    <span>{tab.Title_En}</span>
                  </li>
                  ):""
                  ):(
                    tab.Title ? (
                    <li
                    className={currentTabId === tab.id ? "active" : null}
                    onClick={() => adClick(tab.id)}
                    key={tab.id}
                  >
                    <span>{tab.Title}</span>
                  </li>
                  ):""
                  )
                );
              })
            : null}
        </ul>
      </div>
      
      <button
        onClick={() => setIsMobileActive(!isMobileActive)}
        className={!isMobileActive ? "mobile-toggle" : "mobile-toggle active"}
      >
        <img src={leftmenuicon} alt="sada" />
      </button>
      <div className={!isMobileActive ? "mobile-tabs-corporate" : "mobile-tabs-corporate active"}>
        <ul>
          {tabs
            ? tabs.map((tab) => {
                return (
                  lang == "en" ? (
                    tab.Title_En ? (
                  <li
                    className={currentTabId === tab.id ? "active" : null}
                    onClick={() => adClick(tab.id)}
                    key={tab.id}
                  >
                    <span>{tab.Title_EN}</span>
                  </li>
                  ):""
                  ):( <li
                    className={currentTabId === tab.id ? "active" : null}
                    onClick={() => adClick(tab.id)}
                    key={tab.id}
                  >
                    <span>{tab.Title}</span>
                  </li>)
                );
              })
            : null}
        </ul>
      </div>

      <div className="corporate-container">
        <h3 className="header-three">
          {currentTab ? (lang == "en" ? currentTab.Title_En : currentTab.Title) : "Fotoğraf Galerisi"}
        </h3>
        <div className="corporate-modal otuzlugap">
          {renderContent(currentTab)}
        </div>
      </div>
    </div>
  );
};

export default ImageGallery;
